import type { ThirdPartyFeeConfig, ThirdPartyFeeConfigApi } from '@openx/types/deal';
import { microToPercentWithPrecision } from '@openx/utils/lib/microToPercent';
import { dealThirdPartyFeesConfigDefaultValues } from './constants';

export const parseThirdPartyFeesConfig = (
  // in theory, it should only accept `null | ThirdPartyFeeConfigApi[]`, but the Deal types are broken
  thirdPartyFeesConfig: null | undefined | ThirdPartyFeeConfig[] | ThirdPartyFeeConfigApi[],
  skipPlatformShareParsing = false
): ThirdPartyFeeConfig[] => {
  if (!thirdPartyFeesConfig || thirdPartyFeesConfig.length === 0) {
    return [dealThirdPartyFeesConfigDefaultValues];
  }

  return thirdPartyFeesConfig.map((config: ThirdPartyFeeConfig | ThirdPartyFeeConfigApi) => ({
    gross_cpm_cap: config.gross_cpm_cap ?? '',
    gross_share: microToPercentWithPrecision(config.gross_share) ?? '',
    partner_id: config.partner_id,
    platform_partner_id: config.platform_partner_id,
    platform_share: skipPlatformShareParsing ? '' : (microToPercentWithPrecision(config.platform_share) ?? ''),
    revenue_method: config.revenue_method,
  }));
};
